import React from "react";
import { connect } from "react-redux";

import ContainerNavs from "@/react-components/ContainerNavs";
import MypageResearchInfo from "@/react-components/MypageResearchInfo";
/* import CompanyHeader from "@/react-components/CompanyHeader"; */
import config from "@/utils/config";

class MypageInfoSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navList: config.mypageNavList(
        props.bmServiceStatus,
        props.menuAuthorityInfo
      ),
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps?.bmServiceStatus !== this.props?.bmServiceStatus ||
      prevProps?.menuAuthorityInfo !== this.props?.menuAuthorityInfo
    ) {
      this.setState({
        navList: config.mypageNavList(
          this.props?.bmServiceStatus,
          this.props?.menuAuthorityInfo
        ),
      });
    }
  }

  render() {
    const { navList } = this.state;
    const activeIndex = navList
      .map((item) => item.path)
      .indexOf("/" + this.props?.router?.match?.params?.sitecoreRoute);

    return (
      <div className="my-page-info-container">
        {/* <CompanyHeader /> */}
        {/* ヘッダ */}
        <ContainerNavs navs={navList} isLink={true} activeIndex={activeIndex} />
        {activeIndex === 0 && <MypageResearchInfo />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bmServiceStatus: state?.user?.bmServiceStatus,
    menuAuthorityInfo: state?.user?.menuAuthorityInfo,
  };
};

export default connect(mapStateToProps)(MypageInfoSection);
